<style lang="less" scoped>

  .hot-articles {
    width: 100%;
    height: 364px;
    background-color: #f7f7f7;
    margin-top: 25px;
    box-sizing: border-box;
    padding: 20px 20px;
    border-top: 3px solid #009bdb;

    h3 {
      font-size: 18px;
      color: #424242;
      letter-spacing: 2px;
      font-weight: normal;
      margin-bottom: 10px;
    }

    ul {
      li {
        position: relative;
        p a {
          font-size: 14px;
          color: #434343;
          border-bottom: 1px solid #ededed;
          display: inline-block;
          height: 41px;
          line-height: 41px;
          margin-left: 35px;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        span {
          font-size: 14px;
          color: #fff;
          width: 21px;
          display: inline-block;
          text-align: center;
          background-color: #c4c4c4;
          padding-top: 2px;
          padding-bottom: 2px;
          display: block;
          position: absolute;
          left: 0;
          top: 10px;
        }
      }
      li:nth-of-type(1) span {
        background-color: #f00;
      }
      li:nth-of-type(2) span {
        background-color: #fa3;
      }
      li:nth-of-type(3) span {
        background-color: #07d;
      }
    }
  }

</style>
<template>
  <div class="hot-articles">
    <h3>推荐热文</h3>
    <lh-loading v-if="isLoading"></lh-loading>
    <ul v-else>
      <li v-for="(item, index) in hotArticles">
        <span>{{ index + 1 }}</span>
        <p>
          <router-link :to="item.url">{{ item.title }}</router-link>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
  import ArticleApi from '../../api/article'
  export default{
    data(){
      return {
        hotArticles: [],
        isLoading: true,
      }
    },
    created(){
      this.fetchHotArticles()
    },
    methods: {
      fetchHotArticles() {
        let vm = this
        ArticleApi.getHotArticles(
          {page: 1},
          body => {
            vm.hotArticles = body.results
            vm.buildUrl(vm.hotArticles)
            vm.isLoading = false;
          },
          error => {
            vm.isLoading = false;
            vm.$message({
              type: 'error',
              message: error
            })
          })
      },
      buildUrl(articleList) {
        _.forEach(articleList, article => {
          article.url = '/articles/' + article.id
        })
      },
    },

  }
</script>



// WEBPACK FOOTER //
// HotArticleList.vue?321b2080